
/**
 * Navigation state management
 */
import { NavigationState } from './types';

// Global state to track navigation
export const navigationState: NavigationState = {
  inProgress: false,
  startTime: null,
  timeoutId: null,
  currentPath: null,
  navigationsCount: 0,
  errors: [],
  lastCompletedPath: null,
  // Original properties
  currentRoute: null,
  isNavigating: false,
  timeElapsed: null,
  lastNavigationTimestamp: null,
  navigationId: null
};

// Maximum time (ms) to wait before considering a navigation stuck
export const NAVIGATION_TIMEOUT = 3000; // Reduced from 5000ms for faster feedback
